import type { InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

type PhoneNumberInputProps = {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly onBlur?: () => void;
  readonly placeholder?: string;
  readonly className?: string;
} & Pick<InputHTMLAttributes<HTMLInputElement>, "title">;

const prefixClassName =
  "w-14 shrink-0 cursor-default rounded-l-lg border border-r-0 border-[var(--border)] bg-muted px-2 py-2 text-center text-sm text-muted-foreground";

const phoneClassName =
  "min-w-0 flex-1 rounded-r-lg rounded-l-none border border-[var(--border)] bg-input-background px-3 py-2 text-sm";

export const PhoneNumberInput = ({
  value,
  onChange,
  onBlur,
  placeholder = "Phone",
  className,
  title,
}: PhoneNumberInputProps) => {
  return (
    <div className={twMerge("flex", className)}>
      <input
        type="text"
        value="+1"
        disabled
        readOnly
        tabIndex={-1}
        aria-hidden="true"
        className={prefixClassName}
      />
      <input
        type="tel"
        value={value}
        title={title}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        className={phoneClassName}
      />
    </div>
  );
};
